export default __webpack_public_path__ + "static/media/swirl1_filled-min.a0e73dc1.png";